var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.headerBanner)?_c('component-header-banner',{attrs:{"data":_vm.headerBanner}}):_vm._e(),_vm._v(" "),_c(_vm.componentHeader,{tag:"component",class:_vm.$style.header,on:{"loaded":function($event){return _vm.$emit('loaded')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }